import { render, staticRenderFns } from "./StorageSpaceMediaChangeActivationType.vue?vue&type=template&id=1e87b988&"
import script from "./StorageSpaceMediaChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceMediaChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports